import { Component, OnInit } from "@angular/core";
import { SieniService } from "src/app/shared/services/sieni.service";
import { MOrganization } from "src/app/shared/models/organization.model";
import { MModuleEvaluation } from "src/app/shared/models/module-evaluation.model";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MModule } from "src/app/shared/models/module.model";
import { MModuleDetail } from "src/app/shared/models/module-detail.model";
import { MCurrentVersion } from "src/app/shared/models/current-version.model";
import { MSource } from "src/app/shared/models/source-taker.model";
import { MReportType } from "src/app/shared/models/report-type.model";
import { Alert } from "src/app/shared/models/alert.model";
import { MToolboxDashboard } from "src/app/shared/models/ToolboxDashboard.model";

@Component({
  selector: "app-evaluation-history",
  templateUrl: "./evaluation-history.component.html",
  styleUrls: ["./evaluation-history.component.scss"]
})
export class EvaluationHistoryComponent implements OnInit {
  constructor(
    private _globalService: SieniService,
    private translate: TranslateService,
    private actvRoute: ActivatedRoute,
    private router: Router
  ) {}

  public org: MOrganization = null;
  public search: string = "";
  public module: MModuleDetail = null;
  public version: MCurrentVersion = null;
  public evaluations: MModuleEvaluation[] = null;
  public recommendations: MModuleEvaluation[] = [];
  public filtered: MModuleEvaluation[] = [];
  public selected: number = null;
  public pages: number[] = [];
  public isLoading: boolean = true;
  public reportTypes: MReportType[] = [];
  public reportUrl: string = "";
  public indexes: number[] = [];
  public toolbox: MToolboxDashboard = null;

  ngOnInit() {
    this.translate.setDefaultLang("es");
    this.translate.use(this._globalService.user.language.code);

    const id = parseInt(this.actvRoute.snapshot.paramMap.get("module_id"));
    const versionId = parseInt(
      this.actvRoute.snapshot.paramMap.get("version_id")
    );

    // console.log(id)

    this._globalService.getCurrentOrganization().then(res => {
      this.org = res;
      this._globalService.getCurrentToolbox().then(res => {
        // console.log(res)
        this.toolbox = res;
        this._globalService.getModuleById(id).subscribe(({ data }: any) => {
          // console.log(data, "modulo")
          this.module = new MModuleDetail(data);
          // console.log(this.module)
          for (let i = 0; i < this.module.versions.length; i++) {
            if (this.module.versions[i].id === versionId) {
              this.version = this.module.versions[i];
              break;
            }
          }
          if (!this.version) {
            this.router.navigate(["/sieni"]);
          }
          this._globalService.getReportTypes().subscribe(res => {
            this.reportTypes = res;
            // console.log(this.reportTypes)

            this._globalService
              .getEvaluationHistory()
              .subscribe(({ data }: any) => {
                // console.log(data)
                this.evaluations = [];
                // console.log(data)
                data.forEach(eva => {
                  if (eva.subversion_modulo.version_modulo.id === versionId) {
                    this.evaluations.push(new MModuleEvaluation(eva));
                  }
                });
                // console.log(this.evaluations)
                this.setRecommendations();
              });
          });
        });
      });
    });
  }

  public position(index: number) {
    for (let i = 0; i < this.evaluations.length; i++) {
      if (this.evaluations[i].id === index) {
        return i;
      }
    }
  }

  public setRecommendations() {
    this.recommendations = [];
    if (this.search !== "") {
      for (let i = 0; i < this.evaluations.length; i++) {
        // console.log(this.evaluations[i].startDate)
        if (
          this.formatDate(this.evaluations[i].startDate).indexOf(
            this.search.toLowerCase()
          ) >= 0
        ) {
          this.recommendations.push(this.evaluations[i]);
        } else if (this.evaluations[i].finishDate) {
          if (
            this.formatDate(this.evaluations[i].finishDate).indexOf(
              this.search.toLowerCase()
            ) >= 0
          ) {
            this.recommendations.push(this.evaluations[i]);
          }
        }
      }
    } else {
      this.recommendations = this.evaluations;
    }
    this.pages = [];
    this.selected = 1;
    for (let i = 0; i < Math.ceil(this.recommendations.length / 10); i++) {
      this.pages.push(i + 1);
    }
    this.setFiltered(1);
  }

  private formatDate(date: string): string {
    date = date.substr(0, date.indexOf(" "));
    return date.toLowerCase();
  }

  public setFiltered(index: number) {
    let position = (index - 1) * 10 - 1;
    this.selected = index;
    this.filtered = [];
    for (let i = 1; i < 11; i++) {
      if (this.recommendations[position + i]) {
        this.filtered.push(this.recommendations[position + i]);
      }
    }
    // console.log(this.filtered)
  }

  public next() {
    if (this.selected < Math.ceil(this.recommendations.length / 10)) {
      this.selected++;
      this.setFiltered(this.selected);
    }
  }

  public previous() {
    if (this.selected > 1) {
      this.selected--;
      this.setFiltered(this.selected);
    }
  }

  public checkTakers(takers: MSource[]): boolean {
    for (let i = 0; i < takers.length; i++) {
      if (takers[i].type == 1) {
        return true;
      }
    }
    return false;
  }

  public getReport(id: number) {
    if (this.reportUrl !== "") {
      // console.log(id)
      this.indexes.push(id);
      // console.log(this.indexes)
      let url = this.reportUrl
        .replace("{toolbox_id}", `${this.toolbox.id}`)
        .replace("{id}", `${id}`);
      // console.log(evaluation)
      // console.log(url)
      this._globalService.getReport(url).subscribe(
        (res: any) => {
          // window.open(res.data.url)
          // console.log(res)
          var file = new Blob([res], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          // Alert.buildErrorAlert(this.translate.instant('history.alert.404'))
          this.indexes.splice(this.indexes.findIndex(index => index === id), 1);
        },
        err => {
          // console.error(err)
          this.indexes.splice(this.indexes.findIndex(index => index === id), 1);
          if (err.status === 404)
            Alert.buildErrorAlert(this.translate.instant("history.alert.404"));
          else
            Alert.buildErrorAlert(
              this.translate.instant("history.alert.error")
            );
        }
      );
      // console.log(this.indexes.findIndex(index => index === evaluation.id))
    }
  }

  public checkButtons(id: number): boolean {
    const index = this.indexes.findIndex(index => index === id);
    return index >= 0;
  }
}
